import script from "./PenilaianPresentasi.vue?vue&type=script&setup=true&lang=js"
export * from "./PenilaianPresentasi.vue?vue&type=script&setup=true&lang=js"

import "./PenilaianPresentasi.vue?vue&type=style&index=0&id=255ca120&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-255ca120"]])

export default __exports__